<div class="flex-row" id="duration-data-column">{{ getFormattedValue() }}
 </div>
